// extracted by mini-css-extract-plugin
export var redoItem = "_p8-1";
export var redoTrigger = "_p8-0";